// Συγκριτικά δεδομένα: κριτήρια × 3 θεωρίες, συστήματα ονομάτων, πίνακας μετακίνησης,
// γεωγραφικές συντεταγμένες, επιχειρήματα, χρονολόγιο, κάρτες επισκόπησης.
// Πηγή: το αναλυτικό κείμενο «Η Αναζήτηση της Ομηρικής Ιθάκης» (κεφ. 11-13, 5, 8, 10, 12).

export const THEORIES = [
  { key: 'trad', name: 'Παραδοσιακή άποψη', sub: 'Το σημερινό νησί' },
  { key: 'lefkada', name: 'Λευκάδα', sub: 'W. Dörpfeld, 1900' },
  { key: 'paliki', name: 'Παλική (Κεφαλονιά)', sub: 'Bittlestone · Diggle · Underhill, 2005–2026' },
];

export const SCORE_META = {
  strong: { label: 'Ισχυρή ανταπόκριση', cls: 'bg-aegean text-paper' },
  medium: { label: 'Μέτρια / οριακή', cls: 'bg-[#C9A227]/15 text-[#7A6116] border border-[#C9A227]/40' },
  weak: { label: 'Αδύναμη / αντικρουόμενη', cls: 'bg-terra/10 text-terra border border-terra/40' },
  na: { label: 'Δεν εξετάζεται', cls: 'bg-muted text-muted-foreground border border-line' },
};

export const CRITERIA = [
  {
    criterion: '«Ζόφος» = βορράς',
    source: 'Οδ. ι 26',
    question: 'Είναι η υποψήφια τοποθεσία η βορειότερη του συμπλέγματος;',
    cells: {
      trad: { score: 'weak', note: 'Ικανοποιείται μόνο οριακά — ουσιαστικά στο ίδιο γεωγραφικό πλάτος με το βόρειο άκρο της Κεφαλονιάς (38,47° Β).' },
      lefkada: { score: 'strong', note: 'Δραματικά βορειότερη: 38,50°–38,83° Β, σχεδόν μισός βαθμός πέρα από την Ιθάκη.' },
      paliki: { score: 'na', note: 'Δεν αξιοποιείται ρητά ως επιχείρημα από τη θεωρία.' },
    },
  },
  {
    criterion: '«Χθαμαλή»',
    source: 'Οδ. ι 25',
    question: 'Ταιριάζει το ανάγλυφο/θέση με το επίθετο «χαμηλή» ή «κοντά στην ήπειρο»;',
    cells: {
      trad: { score: 'weak', note: 'Σχετικά ορεινό νησί — η υψηλότερη κορυφή της σημερινής Ιθάκης είναι σε υψόμετρο 800 μ. Και αν υιοθετηθεί η άποψη του Στράβωνα («κείμενη κοντά στην ήπειρο»), δεν ανταποκρίνεται στο κριτήριο.' },
      lefkada: { score: 'strong', note: 'Με την ερμηνεία «κείμενη κοντά στην ήπειρο» (Στράβων): τεκμηριωμένη πρώην χερσόνησος της Ακαρνανίας.' },
      paliki: { score: 'medium', note: 'Χερσόνησος της Κεφαλονιάς — συμβατή με τη στραβώνεια ερμηνεία, χωρίς ρητή ανάπτυξη.' },
    },
  },
  {
    criterion: '«ἐν δήμῳ Ἰθάκης»',
    source: 'Οδ. ν 96',
    question: 'Είναι η Ιθάκη τμήμα ευρύτερης ενότητας κι όχι αυτοτελές νησί;',
    cells: {
      trad: { score: 'weak', note: 'Πλήρες, αυτοτελές νησί — η φράση αντικρούεται δομικά, όχι απλώς εκ σιωπής.' },
      lefkada: { score: 'strong', note: 'Τμήμα της ηπειρωτικής Ακαρνανίας — το ίδιο επιχείρημα ωφελεί εξίσου (ή περισσότερο) τη Λευκάδα.' },
      paliki: { score: 'strong', note: 'Πυρήνας του φιλολογικού επιχειρήματος Diggle–Underhill (2026): η Ιθάκη ως «δῆμος» της Κεφαλονιάς.' },
    },
  },
  {
    criterion: 'Αποφυγή του «νῆσος»',
    source: 'ολόκληρο το corpus',
    question: 'Ο Όμηρος δεν αποκαλεί ποτέ ρητά την Ιθάκη «νῆσο» — ποια θεωρία το εξηγεί;',
    cells: {
      trad: { score: 'weak', note: 'Η σημερινή Ιθάκη είναι οριστικά νησί — η αποφυγή μένει ανεξήγητη.' },
      lefkada: { score: 'strong', note: 'Λύνει ριζικά το πρόβλημα: πρώην χερσόνησος, δεν χρειάστηκε ποτέ να είναι νησί.' },
      paliki: { score: 'medium', note: 'Ισχυρό αλλά εφαρμοσμένο επιλεκτικά — δεν εξηγείται γιατί δεν ισχύει εξίσου για τη Λευκάδα.' },
    },
  },
  {
    criterion: 'Όρος Νήριτον',
    source: 'Ιλ. Β 632 · Οδ. ι 21',
    question: 'Διαθέτει η υποψήφια εμβληματικό, κατάφυτο όρος που δικαιώνει το «Νήριτον εἰνοσίφυλλον»;',
    cells: {
      trad: { score: 'weak', note: 'Δεν υπάρχει σήμερα όρος με την ονομασία «Νήριτον» στη σημερινή Ιθάκη — η υψηλότερή της κορυφή (800 μ.) δεν φέρει το ομηρικό όνομα.' },
      lefkada: { score: 'medium', note: 'Πιθανή ετυμολογική ταύτιση Νήριτον = Νήρικος (ακρόπολη Λευκάδας) — έμμεση, χωρίς ονομαστική συνέχεια.' },
      paliki: { score: 'na', note: 'Δεν αξιοποιείται ρητά ως επιχείρημα από τη θεωρία.' },
    },
  },
  {
    criterion: 'Τοπωνυμική συνέχεια',
    source: 'από την αρχαιότητα έως σήμερα',
    question: 'Υπάρχει αδιάλειπτη χρήση του ονόματος από την αρχαιότητα;',
    cells: {
      trad: { score: 'strong', note: 'Αδιάλειπτη χρήση του ονόματος από την αρχαιότητα έως σήμερα — ανεξάρτητη από φιλολογική ερμηνεία.' },
      lefkada: { score: 'weak', note: 'Το όνομα «Λευκάς» δημιουργήθηκε τον 7ο αι. π.Χ. από τους Κορινθίους — το παλαιότερο ήταν «Νήρικος».' },
      paliki: { score: 'weak', note: 'Καμία τοπωνυμική συνέχεια — εξήγηση Μαρινάτου για «μετακόμιση» του ονόματος.' },
    },
  },
  {
    criterion: 'Αρχαιολογία & γεωλογία',
    source: 'ανασκαφές 1900–σήμερα',
    question: 'Τα ευρήματα εδάφους στηρίζουν την ταύτιση;',
    cells: {
      trad: { score: 'medium', note: 'Μυκηναϊκά ευρήματα (Πελικάτα, «Σχολή Ομήρου»): κατοίκηση, όχι απαραίτητα ταύτιση. Ανάκτορο δεν βρέθηκε.' },
      lefkada: { score: 'medium', note: 'Προϊστορικά νεκροταφεία και τείχη στο Νυδρί (2η χιλιετία π.Χ.) — αποδεκτά, πέραν της διαμάχης ταύτισης.' },
      paliki: { score: 'weak', note: 'Η κρίσιμη γεωλογική πρόβλεψη (πρώην θαλάσσιος δίαυλος) καταρρίφθηκε ύστερα από 20 χρόνια έρευνας.' },
    },
  },
  {
    criterion: 'Διαδρομή Τηλεμάχου',
    source: 'Οδ. ο 295–300',
    question: 'Το ταξίδι από την Πύλο περνά από Εχινάδες/Αχελώο πριν την «Ιθάκη»;',
    cells: {
      trad: { score: 'weak', note: 'Δεν μπορεί να χαραχθεί τέτοια πορεία με κατάληξη τη σημερινή Ιθάκη.' },
      lefkada: { score: 'strong', note: 'Θεωρείται από τους ίδιους τους Λευκαδιστές το ισχυρότερο επιχείρημά τους — πέρασμα από την Ακαρνανία.' },
      paliki: { score: 'na', note: 'Δεν αναπτύσσεται ως στήριγμα της θεωρίας.' },
    },
  },
  {
    criterion: 'Επικοινωνία με τη στεριά μέσω πορθμού',
    source: 'Οδ. δ 671 · Στράβ. 10.2',
    question: 'Συνδέεται η υποψήφια με την ηπειρωτική στεριά μέσω στενού πορθμού/διαύλου;',
    cells: {
      trad: { score: 'weak', note: 'Ο πορθμός της ανοίγει προς την Κεφαλονιά (νησί), όχι προς την ήπειρο — η στεριά απέχει πολύ.' },
      lefkada: { score: 'strong', note: 'Ο δίαυλος της Λευκάδας ανοίγει ακριβώς απέναντι στην Ακαρνανία — άμεση επικοινωνία με τη στεριά.' },
      paliki: { score: 'medium', note: 'Πορθμός προς τον κύριο όγκο της Κεφαλονιάς — εσωτερικός, όχι προς την ηπειρωτική στεριά.' },
    },
  },
  {
    criterion: 'Αστερίς & ενέδρα μνηστήρων',
    source: 'Οδ. δ 844–847',
    question: 'Υπάρχει νησίδα-ενέδρα «μεσσηγὺς Ἰθάκης τε Σάμοιό τε»;',
    cells: {
      trad: { score: 'medium', note: 'Δασκαλειό: στενός πορθμός Ιθάκης–Κεφαλονιάς, συμβατός με την ενέδρα. Μέτρια προς ισχυρή.' },
      lefkada: { score: 'weak', note: 'Ταύτιση με το Αρκούδι (Brewster) — αμφιλεγόμενη έναντι του Δασκαλειού.' },
      paliki: { score: 'na', note: 'Δεν προτείνεται σταθερή ταύτιση Αστερίδος.' },
    },
  },
  {
    criterion: '«μάλα σχεδὸν ἀλλήλῃσι»',
    source: 'Οδ. ι 22',
    question: 'Τα νησιά του συμπλέγματος είναι «πολύ κοντά το ένα στο άλλο»;',
    cells: {
      trad: { score: 'medium', note: 'Ικανοποιητική εγγύτητα, όχι όμως απόλυτη γειτνίαση.' },
      lefkada: { score: 'medium', note: 'Εγγύτητα με Ακαρνανία· το σύμπλεγμα αναδιατάσσεται.' },
      paliki: { score: 'strong', note: 'Λύνει το κριτήριο εξ ορισμού: Παλική–Σάμη θα ήταν τμήματα του ίδιου νησιού, πολύ κοντά.' },
    },
  },
  {
    criterion: '«Κεφαλλῆνες»',
    source: 'Ιλ. Β 631',
    question: 'Ο Οδυσσέας παρουσιάζεται ηγεμόνας των Κεφαλλήνων — πού ταιριάζει;',
    cells: {
      trad: { score: 'weak', note: 'Ο όρος συνδέεται ιστορικά με την Κεφαλονιά, όχι με τη σημερινή Ιθάκη.' },
      lefkada: { score: 'medium', note: 'Ο Στράβων ερμηνεύει «ἤπειρον ἔχον» ως κτήση Κεφαλλήνων στην Ακαρνανία — έμμεση στήριξη.' },
      paliki: { score: 'strong', note: 'Άμεση σύνδεση: η Παλική είναι τμήμα της Κεφαλονιάς, γη των Κεφαλλήνων.' },
    },
  },
];

export const NAMING_SYSTEMS = {
  names: ['Ἰθάκη', 'Σάμη', 'Δουλίχιο', 'Ζάκυνθος'],
  columns: [
    { key: 'trad', label: 'Παραδοσιακή άποψη' },
    { key: 'dorpfeld', label: 'Dörpfeld (1900)' },
    { key: 'paliki', label: 'Bittlestone / Diggle / Underhill (2005–2026)' },
  ],
  rows: {
    'Ἰθάκη': { trad: 'Σημερινή Ιθάκη', dorpfeld: 'Λευκάδα', paliki: 'Παλική (χερσόνησος Κεφαλονιάς)' },
    'Σάμη': { trad: 'Κεφαλονιά', dorpfeld: 'Σημερινή Ιθάκη', paliki: 'Υπόλοιπη Κεφαλονιά' },
    'Δουλίχιο': { trad: 'Νησί των Εχινάδων (Δολίχα/Μακρή)', dorpfeld: 'Κεφαλονιά', paliki: 'Σημερινή Ιθάκη' },
    'Ζάκυνθος': { trad: 'Ζάκυνθος — αμετάβλητη', dorpfeld: 'Ζάκυνθος — αμετάβλητη', paliki: 'Ζάκυνθος — αμετάβλητη' },
  },
  footnote: 'Παρατηρούμε ότι και οι δύο ανταγωνιστικές θεωρίες συμφωνούν τουλάχιστον σε ένα σημείο: η Ζάκυνθος παραμένει σταθερή σε κάθε σενάριο — κανείς δεν αμφισβήτησε ποτέ σοβαρά την ταύτισή της. Το σύνολο της αβεβαιότητας συγκεντρώνεται αποκλειστικά στα άλλα τρία ονόματα.',
};

export const MOVES = [
  { theory: 'Παραδοσιακή άποψη', move: 'Δεν μετακινεί τίποτα.', result: 'Το αίνιγμα ζόφου/χθαμαλής παραμένει άλυτο.' },
  { theory: 'Dörpfeld', move: 'Ιθάκη → Λευκάδα', result: 'Η «Σάμη» έπρεπε να μετακομίσει στη σημερινή Ιθάκη.' },
  { theory: 'Συνέχεια Dörpfeld', move: 'Σάμη → σημερινή Ιθάκη', result: 'Το Δουλίχιο έπρεπε να μετακομίσει στην Κεφαλονιά — όπου, αξίζει να σημειωθεί, επιβιώνει μέχρι σήμερα το τοπωνύμιο «Δούλιχο».' },
  { theory: 'Bittlestone / Diggle–Underhill', move: 'Ιθάκη → Παλική', result: 'Το Δουλίχιο έπρεπε να μετακομίσει στη σημερινή Ιθάκη.' },
  { theory: 'Luce (1998)', move: 'Δουλίχιο → Λευκάδα', result: 'Παραμένει ασαφές τι γίνεται με τη σχέση Λευκάδας–«ηπειρωτικής ακτής».' },
];

export const COORDS = [
  { island: 'Ζάκυνθος', lat: '≈ 37,78° Β', note: 'Η νοτιότερη του συμπλέγματος' },
  { island: 'Κεφαλονιά (κύριος όγκος)', lat: '≈ 38,21° Β', note: 'Βορειότερο άκρο (Φισκάρδο): ≈ 38,47° Β' },
  { island: 'Ιθάκη', lat: '≈ 38,37°–38,40° Β', note: 'Βορειότερο άκρο: ≈ 38,47°–38,48° Β — οριακά «πρώτη»' },
  { island: 'Λευκάδα', lat: '≈ 38,50°–38,83° Β', note: 'Ολόκληρο το νησί βορειότερα — δραματικά καθαρή υπεροχή' },
];

export const ARGUMENTS = {
  trad: {
    title: 'Σημερινή Ιθάκη (παραδοσιακή άποψη)',
    strengths: [
      { text: 'Αδιάλειπτη τοπωνυμική συνέχεια — νομίσματα 4ου–3ου αι. π.Χ. με κεφαλή Οδυσσέα, πρόσφατα ανακαλυφθέν ιερό με επιγραφές λατρείας (Άγιος Αθανάσιος).', strength: 'Πολύ ισχυρή, ανεξάρτητη από φιλολογική ερμηνεία' },
      { text: 'Μυκηναϊκά ευρήματα (Πελικάτα, «Σχολή Ομήρου»).', strength: 'Μέτρια — δείχνει κατοίκηση, όχι απαραίτητα ταύτιση' },
      { text: 'Στενός πορθμός με Κεφαλονιά, συμβατός με την ενέδρα της Αστερίδας.', strength: 'Μέτρια προς ισχυρή' },
    ],
    weaknesses: [
      { text: 'Τα «χθαμαλή» και «ζόφος = βορράς» δεν ταιριάζουν παρά οριακά· η Ιθάκη δεν είναι σαφώς η βορειότερη ή η χαμηλότερη του συμπλέγματος.' },
      { text: 'Το «ἐν δήμῳ Ἰθάκης» περιγράφει δομικά την Ιθάκη ως τμήμα μεγαλύτερης ενότητας — ασύμβατο με πλήρες, αυτοτελές νησί. Πολύ ισχυρή, ενεργά αντικρουόμενη αδυναμία.' },
    ],
  },
  lefkada: {
    title: 'Λευκάδα (Dörpfeld)',
    strengths: [
      { text: '«Ζόφος» = βορράς (ερμηνεία Στράβωνα): η Λευκάδα είναι σαφώς, δραματικά βορειότερη ολόκληρου του συμπλέγματος.', strength: 'Άριστη ανταπόκριση' },
      { text: '«Χθαμαλή» = «κοντά στην ήπειρο»: τεκμηριωμένη πρώην χερσόνησος της Ακαρνανίας.', strength: 'Άριστη ανταπόκριση' },
      { text: 'Λύνει ριζικά το πρόβλημα του «νῆσος» — ήταν χερσόνησος που ακολούθως έγινε νησί.' },
      { text: 'Πιθανή ετυμολογική ταύτιση Νήριτο = Νήρικος, ανεξάρτητη από αμφισβητούμενα χωρία.' },
      { text: 'Διαδρομή Τηλεμάχου προς Εχινάδες/Αχελώο πριν την «Ιθάκη».', strength: 'Το ισχυρότερο επιχείρημα των Λευκαδιστών' },
    ],
    weaknesses: [
      { text: 'Η ταύτιση Αστερίδα–Αρκούδι παραμένει αμφιλεγόμενη έναντι της παραδοσιακής Αστερίδας–Δασκαλειού, που ταιριάζει καλύτερα με τη στενότερη γειτνίαση Ιθάκης–Κεφαλονιάς.' },
    ],
  },
  paliki: {
    title: 'Παλική (Bittlestone / Diggle–Underhill)',
    strengths: [
      { text: 'Φιλολογικό επιχείρημα «αποφυγή νῆσος» + «δῆμος Ἰθάκης».', strength: 'Ισχυρό, αλλά εξίσου γενικεύσιμο και στη Λευκάδα' },
      { text: 'Άμεση σύνδεση με τους «Κεφαλλῆνες» — η Παλική είναι τμήμα Κεφαλονιάς.' },
      { text: 'Λύνει το «μάλα σχεδὸν ἀλλήλῃσι»: Παλική–Σάμη θα ήταν εξ ορισμού πολύ κοντά.' },
    ],
    weaknesses: [
      { text: 'Το γεωλογικό αίτημα (πρώην νησί) παραμένει αμφιλεγόμενο μετά από είκοσι χρόνια έρευνας που δεν το επιβεβαίωσε.' },
      { text: 'Καμία τοπωνυμική συνέχεια, σε αντίθεση με τη σημερινή Ιθάκη.' },
      { text: 'Επιλεκτική εφαρμογή του φιλολογικού επιχειρήματος — δεν εξηγείται γιατί δεν ισχύει εξίσου για τη Λευκάδα.' },
    ],
  },
};

export const TIMELINE = [
  { year: '3ος αι. π.Χ.', who: 'Ερατοσθένης', what: 'Η σκεπτικιστική ρήση: τον τόπο των πλάνητων του Οδυσσέα θα τον βρει όποιος βρει τον τσαγκάρη που έραψε το ασκί των ανέμων.' },
  { year: '1ος αι. π.Χ./μ.Χ.', who: 'Στράβων', what: 'Υπεράσπιση του Ομήρου ως αξιόπιστου γεωγράφου· οι ερμηνείες «χθαμαλή = κοντά στην ήπειρο» και «ζόφος = βορράς» (10.2.12).' },
  { year: '1795', who: 'F. A. Wolf', what: 'Prolegomena ad Homerum — θεμελίωση του Ομηρικού Ζητήματος.' },
  { year: '1807', who: 'W. Gell', what: 'Τοποθετεί την ομηρική πρωτεύουσα στον ισθμό Αετού της σημερινής Ιθάκης.' },
  { year: '1900', who: 'W. Dörpfeld', what: 'Ανακοινώνει στο Γερμανικό Ινστιτούτο Αθηνών: η Λευκάδα είναι η ομηρική Ιθάκη. Ανασκαφές 1901–1913.' },
  { year: '1903–1905', who: 'Wilamowitz εναντίον Dörpfeld', what: 'Καυστική απάντηση του μεγάλου φιλολόγου· ο Dörpfeld ανταπαντά με το Leukas (1905).' },
  { year: '1908', who: 'A. E. H. Goekoop', what: 'Προτείνει τη νότια Κεφαλονιά (λόφος Αγίου Γεωργίου) ως θέση της Ιθάκης.' },
  { year: '1914 / 1926', who: 'A. Shewan', what: 'Εκτεταμένη κριτική της θεωρίας της Λευκάδας στο Journal of Hellenic Studies.' },
  { year: '1927', who: 'Dörpfeld', what: 'Alt-Ithaka, δύο τόμοι — το αποκορύφωμα της θεωρίας της Λευκάδας.' },
  { year: 'δεκ. 1920', who: 'F. Brewster', what: 'Η Λευκάδα ως ομηρική Σάμη· η Αστερίς ως σημερινό Αρκούδι.' },
  { year: '1998', who: 'J. V. Luce', what: 'Η Λευκάδα ως Δουλίχιο, όχι Ιθάκη — επιχείρημα μεγέθους και μνηστήρων.' },
  { year: '2005', who: 'Bittlestone · Diggle · Underhill', what: 'Odysseus Unbound (Cambridge UP): η Παλική ως πρώην νησί = ομηρική Ιθάκη.' },
  { year: '2026', who: 'Diggle & Underhill', what: '«In Search of Ithaca», Antigone Journal: η φιλολογική «διάσωση» — η Ιθάκη ποτέ ρητά «νῆσος», αλλά «δῆμος».' },
];

export const OVERVIEW_CARDS = [
  { id: 'prologue', title: 'Το αίνιγμα', teaser: 'Η Ιθάκη περιγράφεται ταυτόχρονα «χθαμαλή» και «πανυπερτάτη», «πρὸς ζόφον» — και η σημερινή Ιθάκη μάλλον δεν ανταποκρίνεται στην περιγραφή αυτή. Δύο χιλιάδες χρόνια διαμάχης, από τον Ερατοσθένη έως το 2026.' },
  { id: 'matrix', title: 'Οι 3 θεωρίες με μια ματιά', teaser: 'Παραδοσιακή άποψη, Λευκάδα (Dörpfeld), Παλική (Bittlestone–Diggle–Underhill): δώδεκα κρίσιμα κριτήρια, βαθμολογημένα δίπλα-δίπλα — ο πυρήνας ολόκληρης της αντιπαράθεσης.' },
  { id: 'part1', title: 'Το Ομηρικό Ζήτημα', teaser: 'Αναλυτές εναντίον Ενωτικών, ο Κατάλογος των Πλοίων ως ξεχωριστό έγγραφο, και το αμφισβητούμενο τέλος της Οδύσσειας — εκεί ακριβώς βρίσκονται τα κρίσιμα τοπωνύμια.' },
  { id: 'ch4', title: 'Η θεωρία της Λευκάδας', teaser: 'Ο Wilhelm Dörpfeld, συνεργάτης του Schliemann, μετέφερε το 1900 την Ιθάκη στη Λευκάδα: ζόφος = βορράς, χθαμαλή = κοντά στην ήπειρο, και το ταξίδι του Τηλέμαχου ως απόδειξη.' },
  { id: 'ch5', title: 'Η θεωρία της Παλικής', teaser: 'Το Odysseus Unbound (2005) πρότεινε τη χερσόνησο της Παλικής ως πρώην νησί-Ιθάκη. Η γεωλογία αμφισβήτησε το σενάριο — η φιλολογία του 2026 επιχείρησε τη «διάσωση».' },
  { id: 'part3', title: 'Οι πηγές', teaser: 'Οκτώ ομηρικά χωρία με πρωτότυπο κείμενο και απόδοση, και ο Στράβων ως ερμηνευτής με προκαθορισμένο συμπέρασμα.' },
  { id: 'ch10', title: 'Ήταν η Ομηρική Ιθάκη νησί;', teaser: 'Σε ολόκληρο το ομηρικό corpus η Ιθάκη δεν αποκαλείται ποτέ ρητά «νῆσος» — μια σιωπή που τροφοδοτεί τις δύο ανταγωνιστικές θεωρίες.' },
  { id: 'ch13', title: 'Η μεταφορά των ονομάτων', teaser: 'Κάθε θεωρία λύνει το πρόβλημα μετατοπίζοντάς το: το παζλ των τεσσάρων ονομάτων (Ιθάκη–Σάμη–Δουλίχιο–Ζάκυνθος) σε δύο αντικρουόμενα συστήματα.' },
  { id: 'epilogue', title: 'Τι μένει να αποδειχτεί', teaser: 'Καμία θεωρία δεν πλησιάζει τη βεβαιότητα. Μόνο ένα αρχαιολογικό εύρημα που να αποδίδει ρητά σε κάποιο από τα υποψήφια σήμερα νησιά το αντίστοιχο ομηρικό όνομα, θα λύσει το αίνιγμα.' },
];

export const THEORY_TABS = [
  {
    key: 'trad',
    label: 'Παραδοσιακή άποψη',
    assign: { lefkada: 'Λευκάδα', ithaca: 'Ιθάκη', paliki: 'Παλική', cephMain: 'Σάμη', zakynthos: 'Ζάκυνθος', echinades: 'Δουλίχιο' },
    summary: 'Ιθάκη: σημερινή Ιθάκη · Σάμη: Κεφαλονιά · Δουλίχιο: Εχινάδες · Ζάκυνθος: αμετάβλητη',
  },
  {
    key: 'dorpfeld',
    label: 'Dörpfeld (1900)',
    assign: { lefkada: 'Ιθάκη', ithaca: 'Σάμη', paliki: 'Παλική', cephMain: 'Δουλίχιο', zakynthos: 'Ζάκυνθος', echinades: 'Εχινάδες' },
    summary: 'Ιθάκη: Λευκάδα · Σάμη: σημερινή Ιθάκη · Δουλίχιο: Κεφαλονιά · Ζάκυνθος: αμετάβλητη',
  },
  {
    key: 'paliki',
    label: 'Θεωρία Bittlestone–Diggle–Underhill',
    assign: { lefkada: 'Λευκάδα', ithaca: 'Δουλίχιο', paliki: 'Ιθάκη', cephMain: 'Σάμη', zakynthos: 'Ζάκυνθος', echinades: 'Εχινάδες' },
    summary: 'Ιθάκη: Παλική · Σάμη: υπόλοιπη Κεφαλονιά · Δουλίχιο: σημερινή Ιθάκη · Ζάκυνθος: αμετάβλητη',
  },
];

export const MAP_LABELS = [
  { old: 'I. St. Maura', modern: 'Λευκάδα', note: 'Το βορειότερο νησί του χάρτη — η υποψήφια του Dörpfeld, δίπλα στην ακαρνανική ακτή.' },
  { old: 'I. Tiachi', modern: 'Ιθάκη', note: 'Η σημερινή Ιθάκη, σφηνωμένη ανάμεσα σε Λευκάδα και Κεφαλονιά — ούτε η βορειότερη, ούτε χαμηλή.' },
  { old: 'I. Cephalonia (Palari)', modern: 'Κεφαλονιά & Παλική', note: 'Διακρίνεται καθαρά η δυτική χερσόνησος Παλική — η υποψήφια των Bittlestone–Diggle–Underhill.' },
  { old: 'I. Zante', modern: 'Ζάκυνθος', note: 'Το μόνο όνομα που κανείς δεν αμφισβήτησε ποτέ — σταθερό σε κάθε θεωρία.' },
];

export const IMAGES = {
  bust: 'https://images.pexels.com/photos/37727418/pexels-photo-37727418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  map: 'https://images.unsplash.com/photo-1520299607509-dcd935f9a839?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxhbmNpZW50JTIwbWFwJTIwdG9wb2dyYXBoeSUyMHRleHR1cmV8ZW58MHx8fHwxNzg5Nzk3ODIxfDA&ixlib=rb-4.1.0&q=85',
  sea: 'https://images.unsplash.com/photo-1658957471049-bdb226b9fffc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxpb25pYW4lMjBzZWElMjBncmVlY2UlMjBpc2xhbmR8ZW58MHx8fHwxNzg5Nzk3ODIxfDA&ixlib=rb-4.1.0&q=85',
};
